import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
// import styles from './PersonalInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { StatusInputWrapper } from '../../../../shared/components/StatusInputWrapper'

const FirstName = ({ t, validateFirstName, firstNameError, firstNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const firstName = useSelector((state) => state.app.personalInformation.firstName)

  const handleFirstName = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(changeObjectPropertyAction('personalInformation', 'firstName', name))
      validateFirstName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurFirstName = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(changeObjectPropertyAction('personalInformation', 'firstName', name))
      if (name) {
        validateFirstName(name)
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      {/* <div
        className={[
          firstNameValid === true
            ? firstName === ''
              ? ''
              : 'form-group has-success'
            : firstNameValid === false
              ? 'form-group has-error'
              : '',
          styles['fields_margin'],
        ].join(' ')}
      >
        <label className="control-label" htmlFor="FirstName">
          {t('personal_info.first_name')}
        </label>
        <input
          type="text"
          id="FirstName"
          className={['form-control', styles['field_width_200']].join(' ')}
          value={firstName}
          onChange={handleFirstName}
          onBlur={onBlurFirstName}
          onFocus={() => SetIsFocussed(true)}
          autoComplete="off"
          maxLength="150"
        />
        {firstNameValid === true ? (
          firstName === '' ? (
            ''
          ) : (
              <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            )
        ) : firstNameValid === false ? (
          <React.Fragment>
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(firstNameError)}</div>
          </React.Fragment>
        ) : (
              ''
            )}
      </div> */}
      <StatusInputWrapper
        isValid={firstNameValid}
        errorMsg={firstNameError}
        t={t}
        label={t('personal_info.first_name')}
        customClasses={'fw-20'}
        id="FirstName" name="FirstName" type="text"
        aria-describedby="first-name"
        onChange={handleFirstName}
        onBlur={onBlurFirstName}
        onFocus={() => SetIsFocussed(true)}
        isFocussed={isFocussed}
        value={firstName}
        autoComplete="off"
        maxLength="200"
      />
    </React.Fragment>
  )
}

export default withTranslation('common')(FirstName)